import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { TRole } from '@src/types/course';
import { ROLE_TEACHER, ROLE_STUDENT } from '@src/const/course';

const Name = styled.div`
	color: #101010;
`;

const Date = styled.div`
	color: #676767;
	font-size: 14px;
`;

const BoughtChip = styled.div`
	padding: 4px 12px;
	background: #ECECEC;
	border-radius: 50px;
	border: 1px solid #C4C4C4;
	box-sizing: border-box;
	font-size: 14px;

	@media ${props => props.theme.device.lgDesktop} {
		font-size: 16px;
	}

	@media ${props => props.theme.device.mobile} {
		margin-bottom: 8px;
	}
`;

const TeacherChip = styled.div`
	padding: 4px 12px;
	background: #676767;
	color: #FFFFFF;
	border-radius: 50px;
	font-size: 14px;

	@media ${props => props.theme.device.mobile} {
		margin-bottom: 8px;
	}
`;

const UserInfoWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	margin-bottom: 12px;

	& > *:not(:last-child) {
		margin-right: 16px;
	}

	@media ${props => props.theme.device.mobile} {
		flex-direction: column;
		align-items: flex-start;

		& > *:not(:last-child) {
			margin-right: 0px;
		}
	}
`;

interface IUserInfo {
	role: TRole;
	bought: boolean;
	name: string;
	createAt: string;
}

const UserInfo = ({ role, bought = false, name, createAt }: IUserInfo): JSX.Element => {
	const { t } = useTranslation();

	return (
		<UserInfoWrapper>
			{role === ROLE_STUDENT && bought && (
				<BoughtChip>{t('course:discussions:student')}</BoughtChip>
			)}
			{role === ROLE_TEACHER && (
				<TeacherChip>{t('course:discussions:teacher')}</TeacherChip>
			)}
			<Name>{name}</Name>
			<Date>{createAt}</Date>
		</UserInfoWrapper>
	);
};

export default UserInfo;
